import React, { useMemo } from 'react';
import { Handle, Position } from 'reactflow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Icons from "../Icons";

const isNodeDataComplete = (data, metadata) => {
  if (!metadata) return true;
  for (const field of metadata) {
    if (field.required && (data[field.name] === undefined || data[field.name] === null || data[field.name] === '')) {
      return false;
    }
  }
  return true;
};

/**
 * Node "Thử / Bắt lỗi": có 2 cổng đầu ra — thành công (successHandleId) và lỗi (errorHandleId).
 */
const Node = ({nodeName, data, id, selected, metadata, type, style = {} }) => {
  const isComplete = isNodeDataComplete(data, metadata);

  const handles = useMemo(() => ([
    { id: String(data.successHandleId || 'success').trim() || 'success', label: 'success', color: '#2ECC71' },
    { id: String(data.errorHandleId || 'error').trim() || 'error', label: 'error', color: '#E74C3C' },
  ]), [data.successHandleId, data.errorHandleId]);

  let statusClass;
  if (data.disabled) {
    statusClass = 'node-disabled';
  } else {
    statusClass = ((data || {}).nodeState || {}).status ? `node-status-${((data || {}).nodeState || {}).status}` : 'node-status-pending';
  }

  return (
    <div className={`base-node ${statusClass} ${selected ? 'selected-node' : ''}`} style={{ border: '1px solid #ccc', paddingTop: 10, paddingBottom: 10, minWidth: 160, ...style }}>
      <Handle type="target" position={Position.Left} isConnectable={true} />
      {!isComplete && <div className="node-warning">⚠️</div>}

      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
        <FontAwesomeIcon icon={Icons[type] || Icons.default} className="node-icon" style={{ color: style.color }} />
        <div style={{ textAlign: "center" }} className="name-node">{nodeName || data.name || "Thử / Bắt lỗi"}</div>
      </div>

      <div style={{ position: 'relative', marginTop: 5 }}>
        {handles.map((h, index) => (
          <div key={h.id} style={{ position: 'relative', height: 20, marginBottom: 5 }}>
            <Handle
              type="source"
              position={Position.Right}
              id={h.id}
              style={{ background: h.color, top: `${(index + 1) * (100 / (handles.length + 1))}%` }}
            />
            <span style={{
              position: 'absolute', right: '15px',
              top: `${(index + 1) * (100 / (handles.length + 1))}%`,
              transform: 'translateY(-50%)', fontSize: '0.7em', color: h.color,
              background: 'rgba(255, 255, 255, 0.85)', padding: '1px 3px', borderRadius: '2px', pointerEvents: 'none'
            }}>
              {h.label}
            </span>
          </div>
        ))}
      </div>

      {((data || {}).nodeState || {}).status && <div className="status-node">{((data || {}).nodeState || {}).status}</div>}
    </div>
  );
};

export default Node;
